export const expired = (date: string, expireDays: number): boolean => {
  const expiredAt = new Date(date);
  expiredAt.setDate(expiredAt.getDate() + expireDays);
  return expiredAt < new Date();
};

export const isExpired = (milliseconds: number): boolean =>
  milliseconds < Date.now();

export const isFuture = (milliseconds: number): boolean =>
  milliseconds > Date.now();
